import React from "react";
import { Box, Typography, Button } from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: React.ReactNode;
}

export function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon
}: EmptyStateProps) {
  const { t } = useTranslation();
  const titleText = title ?? t("common.emptyTitle");
  const descriptionText = description ?? t("common.emptyDescription");
  return (
    <Box sx={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", py: 10, px: 4, textAlign: "center"
    }}>
      <Box sx={{ color: "text.disabled", mb: 2, fontSize: 56 }}>
        {icon ?? <InboxIcon sx={{ fontSize: 56 }} />}
      </Box>
      <Typography variant="h6" color="text.secondary" gutterBottom>{titleText}</Typography>
      <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 320 }}>{descriptionText}</Typography>
      {actionLabel && onAction && (
        <Button variant="outlined" onClick={onAction} sx={{ mt: 3 }}>{actionLabel}</Button>
      )}
    </Box>
  );
}
